import React from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

interface CheckboxOneProps extends CheckboxProps {
  fontSize?: number;
  disabled?: boolean;
}

export const CheckboxOne: React.FC<CheckboxOneProps> = (props) => {
  return (
    <Checkbox
      disableRipple
      disabled={props.disabled}
      sx={{
        '& .MuiSvgIcon-root': { fontSize: props.fontSize !== undefined ? props.fontSize : 20 },
        '&.Mui-checked': {
          color: '#3C419A',
        },
        '&.Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
        },
        '&.Mui-focus': {
          outline: '2px solid rgb(0,0,0)',
          outlineOffset: '1px',
        },
        ...props.sx,
      }}
      {...props}
    />
  );
};
